/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import BidSetting from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/bid-setting';
import '@bingads-webui-campaign/ko-stop-binding';

import { getStyles } from './style';

// For sponsored campaigns for the moment
export const LegacyBidSetting = React.memo(({
  id,
  className,
  onChange,
  activity,
  budgetAmount,
  validateWithBudget,
  defaultBidValue,
}) => {
  const view = useRef();
  let container;

  useEffect(() => {
    view.current = new BidSetting({
      activityLogger: activity,
      isAudienceCampaign: false,
      isMSStoreCampaign: false,
      withRealTimeValidation: true,
      onChange,
      budgetAmount,
      defaultBidValue,
      validateWithBudget,
    });

    view.current.render();
    view.current.$el.appendTo(container);

    return () => view.current.remove();
  }, [budgetAmount]);

  const classes = useDefaultStyles(getStyles);

  return (
    <div
      id={id}
      className={classnames(className, classes.bidSetting)}
    >
      <div ref={(ref) => { container = ref; }} />
    </div>
  );
});

LegacyBidSetting.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  activity: PropTypes.shape({}),
  budgetAmount: PropTypes.number,
  defaultBidValue: PropTypes.number,
  validateWithBudget: PropTypes.bool,
};

LegacyBidSetting.defaultProps = {
  id: undefined,
  className: undefined,
  activity: undefined,
  budgetAmount: null,
  defaultBidValue: null,
  validateWithBudget: false,
};
